import React from 'react';

const WizardIcon = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1
    }
  }, "Wizard"), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "30",
    viewBox: "0 0 128 128",
    width: "30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m89.741 38.259a4.887 4.887 0 0 0 -6.792-.079l-63.721 60.8a6.923 6.923 0 0 0 4.772 11.937h.084a6.864 6.864 0 0 0 4.927-2.144l52.4-54.91 8.405-8.808a4.887 4.887 0 0 0 -.079-6.792zm-63.259 68.1a3.422 3.422 0 1 1 -4.838-4.839l53.456-51.012a12.265 12.265 0 0 0 2.392 2.392zm60.808-63.724-7.369 7.722a9.723 9.723 0 0 1 -2.278-2.278l7.722-7.369a1.37 1.37 0 0 1 1.9.023 1.368 1.368 0 0 1 .025 1.902z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.533 34.217a1.745 1.745 0 0 0 1.238-.513l6.992-6.992a1.75 1.75 0 0 0 -2.475-2.475l-6.988 6.992a1.751 1.751 0 0 0 1.237 2.988z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.491 30.471a1.749 1.749 0 0 0 1.75-1.75v-9.888a1.75 1.75 0 0 0 -3.5 0v9.888a1.749 1.749 0 0 0 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.212 33.7a1.75 1.75 0 0 0 2.475-2.475l-6.992-6.992a1.75 1.75 0 0 0 -2.474 2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.816 43.259h9.884a1.75 1.75 0 0 0 0-3.5h-9.884a1.75 1.75 0 0 0 0 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.491 52.546a1.749 1.749 0 0 0 -1.75 1.75v9.888a1.75 1.75 0 0 0 3.5 0v-9.884a1.749 1.749 0 0 0 -1.75-1.754z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.771 49.313a1.75 1.75 0 0 0 -2.471 2.475l6.992 6.991a1.75 1.75 0 0 0 2.475-2.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.167 39.759h-9.888a1.75 1.75 0 0 0 0 3.5h9.888a1.75 1.75 0 0 0 0-3.5z"
  }))));
};

export default WizardIcon;